import { NotificationBanner } from '@/features/notifications/components/NotificationBanner';
import { WrapBanner } from '@/features/wrap/components/WrapBanner';
import useWrapBanner from '@/features/wrap/hooks/useWrapBanner';

/**
 * Single banner slot: the year-in-review nudge takes priority over the
 * notification prompt so the two never stack.
 */
export function AppBanners() {
  const wrap = useWrapBanner();

  return (
    <>
      <WrapBanner shouldShow={wrap.shouldShow} dismiss={wrap.dismiss} year={wrap.year} />
      {!wrap.occupiesSlot && <NotificationBanner />}
    </>
  );
}
